<template>
	<div class="border-y border-zt-light rounded-zt border-x">
		<div v-for="(pos, index) in positionOrder">
			<div v-if="playersByPosition[pos.value]" class="text-xs font-semibold bg-zt-light-full p-2.5 border-b border-zt-light flex justify-between">
				<div>
					{{ pos.label }}
				</div>
				<div v-if="index === 0" class="w-[150px]">
					Klub
				</div>
			</div>
			<div v-for="player in playersByPosition[pos.value]"
			     :class="{ 'border-b' : pos.value !== 'coach' }"
			     class="bg-zt-light/35 border-zt-light p-2.5 text-[13px] font-normal flex justify-between">
				<div class="line-clamp-1 text-ellipsis break-all pr-2 max-w-[calc(100%-140px)] font-light opacity-70">
					{{ player.name }}
				</div>
				<div v-if="pos.value !== 'coach'" class="w-[150px] flex items-start text-ellipsis">
					<a v-if="player.origin_team_id !== '-1'" :href="`/wyniki-pilka-nozna/druzyny/${player.team_query_name}/`"
             class="no-default-style zt-hover flex items-center gap-x-2.5">
						<TeamImg :team="{ team_id: +player.origin_team_id, query_name: player.team_query_name, name: 'a' }"
                     class="h-5 w-5"/>
						<div class="line-clamp-1">
						  {{ player.team_short_name?.length > 0 ? player.team_short_name : player.team_name }}
						</div>
					</a>
					<p v-else class="flex items-center gap-x-2.5">
						<img :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'" alt="fallback"
                 width="20" height="20"/>
						{{ player.origin_team_name.length > 0 ? player.origin_team_name : 'Brak klubu' }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TeamImg from './TeamImg.vue';

export default {
	name: 'TeamSquad',
	components: {TeamImg},
	props: {
		squad: {
			type: Array,
			required: true,
		}
	},
	data: () => ({
		positionOrder: [
			{
				label: 'Bramkarze',
				value: 'goalkeeper'
			},
			{
				label: 'Obrońcy',
				value: 'defender'
			},
			{
				label: 'Pomocnicy',
				value: 'midfielder'
			},
			{
				label: 'Napastnicy',
				value: 'attacker'
			},
			{
				label: 'Trener',
				value: 'coach'
			},
		]
	}),
	methods: {
		formatName(name) {
			if (this.countryWithLongNames) {
				return name;
			}
			const nameParts = name.split(' ');
			return `${ nameParts[0][0] }. ${ nameParts[nameParts.length - 1] }`;
		}
	},
	computed: {
		countryWithLongNames() {
			return this.squad.some(player => player.name.split(' ').length > 3);
		},
		playersByPosition() {
			const squad = {};
			for (const player of this.squad) {
				if (player.name === null) {
					continue;
				}
				const position = player.position.toLowerCase();
				if (!squad.hasOwnProperty(position)) {
					squad[position] = [];
				}
				squad[position].push(player);
			}
			return squad;
		}
	}
}
</script>